
// Scopes a lots list to a client's related lots. Shared by LotsDropDown and the
// Pricing Management views so the client→lot scoping rule lives in one place. When
// the client has no configured lots (or no client is given), the list is returned unchanged.
export function getClientScopedLots(lots, clientsWithConfigs, clientId) {
    const clientConfig = clientsWithConfigs?.find(c => c.id == clientId);
    if (clientConfig?.clientLots?.length > 0) {
        return (lots ?? []).filter(lot => clientConfig.clientLots.find(l => l.lotId == lot.id));
    }
    return lots ?? [];
}

export function getLotsWithTenantText(lots, tenantName) {
    let lotsWithTenantText = [];
    lots?.forEach(lot => {
        let l = { ...lot };
        if (!l.ownedByTenant) {
            l.name = lot.name + ' (Non ' + tenantName + ' Lot)';
        }
        lotsWithTenantText.push(l);
    });
    return lotsWithTenantText;
}